export default "__VITE_ASSET__QwxbPUfF__"